import { useEffect } from "react";

/** Update <title> + meta description on mount for SPA SEO. */
export default function useSeo({ title, description, canonical, keywords }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setOg = (property, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", property);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel, href) => {
      if (!href) return;
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };
    setMeta("description", description);
    setMeta("keywords", keywords);
    if (title) {
      setOg("og:title", title);
      setOg("twitter:title", title);
    }
    if (description) {
      setOg("og:description", description);
      setOg("twitter:description", description);
    }
    if (canonical) {
      setOg("og:url", canonical);
      setLink("canonical", canonical);
    }
  }, [title, description, canonical, keywords]);
}
